import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, showToast, getFetchError, getCatchError} from '../app_common.js';

export const getApiEdge = async(status, pagePer, pageCur, sortTitle, sortOrder) => {
    if( !checkPermission('getApiEdge', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge?status=${status}&per_page=${pagePer}&page=${pageCur}${sortTitle.length>0?'&sort_title='+sortTitle:''}${sortOrder.length>0?'&sort_order='+sortOrder:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeId = async(edgeId) => {
    if( !checkPermission('getApiEdgeId', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeIdChanges = async(edgeId) => {
    if( !checkPermission('getApiEdgeIdChanges', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/changes`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeIdMetrics = async(edgeId) => {
    if( !checkPermission('getApiEdgeIdMetrics', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/metrics`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "text/plain",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const txt = await response.text();
            getFetchError(response, txt, false);
            return txt;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeIdAlertStatus = async(edgeId, pagePer, pageCur, alertFilter = "", sortOrder = "") => {
    if( !checkPermission('getApiEdgeIdAlertStatus', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/alert-status?per_page=${pagePer}&page=${pageCur}${alertFilter.length>0?'&alert_filter='+alertFilter:''}${sortOrder.length>0?'&sort_order='+sortOrder:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiEdgeIdAlertStatus = async(edgeId, alertFilter = "") => {
    if( !checkPermission('delApiEdgeIdAlertStatus', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/alert-status${alertFilter.length>0?'?alert_filter='+alertFilter:''}`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiEdgeIdAlertResolved = async(edgeId, alertFilter = "") => {
    if( !checkPermission('delApiEdgeIdAlertResolved', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/alert-resolved${alertFilter.length>0?'?alert_filter='+alertFilter:''}`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeIdAlertStatusCount = async(edgeId, alertFilter = "") => {
    if( !checkPermission('getApiEdgeIdAlertStatusCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/alert-status-count${alertFilter.length>0?'?alert_filter='+alertFilter:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeIdAlertStatusSummary = async(edgeId) => {
    if( !checkPermission('getApiEdgeIdAlertStatusSummary', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/alert-status-summary`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeIdHistroy = async(edgeId, pagePer, pageCur) => {
    if( !checkPermission('PERMISSION_MONITORING', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/history?per_page=${pagePer}&page=${pageCur}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiEdgeIdHistroy = async(edgeId) => {
    if( !checkPermission('delApiEdgeIdHistroy', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/history`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeIdHistroyCount = async(edgeId) => {
    if( !checkPermission('getApiEdgeIdHistroyCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/history-count`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiEdgeIdStatus = async(status, edgeId) => {
    if( !checkPermission('putApiEdgeIdStatus', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/status?status=${status}`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiEdgeIdConfig = async(edgeId, postData) => {
    if( !checkPermission('putApiEdgeIdConfig', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge/${edgeId}/config`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                "accept": "application/json",
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(postData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeSummary = async(status) => {
    if( !checkPermission('getApiEdgeSummary', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge-summary?status=${status}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiEdgeCount = async(status) => {
    if( !checkPermission('getApiEdgeCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/edge-count?status=${status}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}
